import HelperMixin from "@/mixins/HelperMixin";
import { mapState } from "vuex";
import AppInput from "@/components/AppInput";
import AppSwitch from "@/components/AppSwitch";
import AppPopover from "@/components/AppPopover";
import PercentageValue from "@/components/tableElements/PercentageValue";
import { CurrencyValue } from "@/components/tableElements";
import PpcBudgetAllocationCircle from "@/components/PpcBudgetAllocationCircle";
import AmazonIcon from "@/components/icons/AmazonIcon.vue";
import SettingHexagonIcon from "@/components/icons/SettingHexagonIcon.vue";
import CalendarWithArrowLeftIcon from "@/components/icons/CalendarWithArrowLeftIcon.vue";
export default {
  name: "PpcSbBudgetAllocationHeader",
  emits: ["update:mode", "update:search"],
  mixins: [HelperMixin],
  components: {
    AppInput,
    AppSwitch,
    AppPopover,
    PpcBudgetAllocationCircle,
    PercentageValue,
    CurrencyValue,
    AmazonIcon,
    SettingHexagonIcon,
    CalendarWithArrowLeftIcon
  },
  props: {
    mode: {
      type: String,
      default: "acos"
    },
    search: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default: () => []
    },
    currency: {
      type: String
    },
    still_initializing: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      modes: [{
        value: "roas",
        label: "ROAS"
      }, {
        value: "acos",
        label: "ACOS"
      }],
      currency_precision: 0
    };
  },
  computed: {
    ...mapState({
      sb_ppc_campaigns: state => state.ppc_settings.sb_ppc_campaigns
    }),
    localMode: {
      get() {
        return this.mode;
      },
      set(value) {
        this.$emit("update:mode", value);
      }
    },
    localSearch: {
      get() {
        return this.search;
      },
      set(value) {
        this.$emit("update:search", value);
      }
    },
    availableBudget() {
      // TO-DO
      // Neet to get from API
      return 30000;
    },
    enabledItems() {
      return this.items.filter(item => item.state === "ENABLED");
    },
    totalBudget() {
      return this.enabledItems.reduce((acc, item) => {
        return acc + item.weekly_budget * 1;
      }, 0);
    },
    totalVariation() {
      return this.enabledItems.reduce((acc, item) => {
        return acc + (item.weekly_budget * 1 - item.last_week_spend * 1);
      }, 0);
    },
    totalLastWeekSpend() {
      return this.enabledItems.reduce((acc, item) => {
        return acc + item.last_week_spend * 1;
      }, 0);
    }
  }
};